import { setPersistedAtValue } from '../../../actions/travelKe/persistedAt';

export const travelKePersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
};
